import React, { forwardRef } from "react";
import { Heading } from "../../typography/index.js";
export const FormSummaryHeading = forwardRef((props, ref) => (React.createElement(Heading, Object.assign({ ref: ref }, props, { size: "medium" }))));
export default FormSummaryHeading;
//# sourceMappingURL=FormSummaryHeading.js.map